// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { fontConfig } from "@stoneage/XDL/constants";
import { color } from "@stoneage/XDL/Utilities";
import React from "react";
import { css } from "styled-components";

interface LocationTypeTagsStyles {
    locationTypeWrapper?: InjectableCss;
    locationTypeTypography?: TypographyPresentationProps;
}

interface LocationTypeTagsProps {
    locationType?: string;
}

export const locationTypeTagsStyles: LocationTypeTagsStyles = {
    locationTypeWrapper: {
        css: css`
            display: flex;
            gap: 8px;
            flex-wrap: wrap;
            padding-top: 12px;
            margin-top: 12px;
            border-top: 1px solid ${color("common.border")};
        `,
    },
    locationTypeTypography: {
        color: "common.ui8",
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.medium,
    },
};

const styles = locationTypeTagsStyles;

const LocationTypeTags: React.FC<LocationTypeTagsProps> = ({ locationType }) => {
    const types = locationType?.split("|") ?? [];

    if (types.length === 0) {
        return null;
    }

    return (
        <StyledWrapper {...styles.locationTypeWrapper}>
            {types.map((type, index) => (
                <React.Fragment key={type}>
                    <Typography {...styles.locationTypeTypography}>{type}</Typography>
                    {index !== types.length - 1 && <Typography {...styles.locationTypeTypography}>|</Typography>}
                </React.Fragment>
            ))}
        </StyledWrapper>
    );
};

export default LocationTypeTags;
